<template>
	<Page animate>
		<template v-slot:content>
			<SafeAreaTop :show-close="false">
				<div class="container">
					<div class="survey-title">Where did you hear about us?</div>
					<SurveySelect :options="options" @change="onChange" type="multiple" theme="light" />
				</div>
			</SafeAreaTop>
		</template>

		<template v-slot:footer>
			<div class="container">
				<a @click.prevent="handleSubmit" href="" class="btn btn-primary btn-block">Send</a>
			</div>
		</template>
	</Page>
</template>

<script>
import Page from '@/components/Page'
import SurveySelect from '@/components/SurveySelect.vue'
import SafeAreaTop from '@/components/SafeAreaTop'
import { computed } from '@vue/reactivity'
import { useStore } from 'vuex'
import { inject, onMounted } from '@vue/runtime-core'
import useApi from '@/composition/api.js'

export default {
	components: {
		Page,
		SurveySelect,
		SafeAreaTop
	},

	setup() {
		const store = useStore()
		const amplitude = inject('amplitude')
		const api = useApi()

		const options = computed(() => {
			return store.getters['survey/getProperty']({
				key: 'ads_source',
				options: [
					{
						label: 'Search'
					},
					{
						label: 'Facebook'
					},
					{
						label: 'Instagram'
					},
					{
						label: 'TikTok'
					},
					{
						label: 'TV'
					},
					{
						label: 'YouTube'
					},
					{
						label: 'App Store / Play Store'
					},
					{
						label: 'Other'
					}
				]
			})
		})

		const selected = computed(() => options.value.filter((option) => option.selected))

		const onChange = (option) => {
			store.commit('survey/update', {
				property: 'ads_source',
				value: option
			})
		}

		const handleSubmit = () => {
			amplitude.logEvent('OnboardingWhereYouHearScreenDone', {
				data: selected.value.map((option) => option.label)
			})
			api.close()
		}

		onMounted(() => {
			amplitude.logEvent('ScreenView', {
				title: 'OnboardingWhereYouHearScreen'
			})
		})

		return {
			options,
			onChange,
			handleSubmit
		}
	}
}
</script>

<style scoped lang="scss">
.survey-title {
	font-size: 2rem;
	font-weight: bold;
	line-height: 1.3;
	text-align: center;
	padding-top: 2rem;
	color: #424982;
}

.skip-link {
	padding: 1rem 4rem;
	display: inline-block;
	text-decoration: none;
	font-weight: 500;
	color: #7d8bf7;
	font-size: 1.1rem;
	margin-bottom: 0.5rem;
}
</style>
